import {
  CONTACT_FORM_REQUEST,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_FAILURE,
  CONTACT_FORM_RESET
} from './contactUsActionTypes';

const initialState = {
  loading: false,
  success: false,
  error: null,
  message: '',
  timestamp: null
};

export const contactUsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
        message: ''
      };
      
    case CONTACT_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        message: action.payload.message,
        timestamp: action.payload.timestamp
      };
      
    case CONTACT_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        message: action.payload
      };
      
    case CONTACT_FORM_RESET:
      return {
        ...initialState
      };
      
    default:
      return state;
  }
};